import { useCallback, useContext, useEffect, useState } from 'react'
import CreateRoomModal from 'components/Modal/CreateRoomModal'
import SearchBar from 'pages/HomePage/components/SearchBar'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import addRoomIcon from 'assets/images/roompage-add.svg'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useAtom } from 'jotai'
import { roomListFilteredAtom, roomSearchAtom } from 'config/store'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PATHS } from 'config/routes'
import { useQuery } from 'react-query'
import LoginWebModal from 'components/Modal/LoginWebModal'
import { getUserinfo } from 'utils/localStorage'
import {
	getListRoomOfGameQuery,
	useCreateRoomByPlayNowOfGame,
} from 'dataLayer/game'
import { SocketContext } from 'utils/socket'
import { showSnackbar } from 'store/actions'
import { useDispatch } from 'react-redux'

function RoomSearchAndCreate({ dataList, randomRoom, level }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const { roomId } = useParams()
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const user = getUserinfo()
	// const { dataList: user } = useQuery(getUserQuery())

	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)
	function openLoginModal() {
		window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
	}

	const [modalCreateRoom, setModalCreateRoom] = useState(false)
	function openCreateRoom() {
		if (user) {
			setModalCreateRoom(true)
		} else {
			isMobileMD ? navigate(PATHS.LOGIN_PASS_MOBILE) : openLoginModal()
		}
	}
	function closeCreateRoom() {
		setModalCreateRoom(false)
	}
	const _createRoomByPlayNowSuccess = result => {
		if (result) {
			let data = result.data.playing
			socket.emit('join room', { room_id: data.room_id })
			// setSocketRoomId(data.room_id)
			// navigate(
			// 	PATHS.PLAYROOM_PAGE.replace(':roomId', data.game_id).replace(
			// 		':gameId',
			// 		data.room_id,
			// 	),
			// )
		}
		dispatch(showSnackbar(true, t('modal.success'), 'success'))
	}
	const _createRoomByPlayNowError = data => {
		dispatch(showSnackbar(true, data.message || "Can't play now!", 'error'))
	}
	const { mutate } = useCreateRoomByPlayNowOfGame(
		_createRoomByPlayNowSuccess,
		_createRoomByPlayNowError,
	)
	const handlePlayNow = useCallback(() => {
		if (getUserinfo()) {
			mutate({
				game_id: roomId,
				level_id: level,
			})
		} else {
			openLoginModal()
		}
	}, [roomId, level])

	const [roomSearch, setRoomSearch] = useAtom(roomSearchAtom)
	const roomListFilteredID = dataList
		?.map(item => item.id)
		?.filter(item =>
			item.toString().toLowerCase().includes(roomSearch.toLowerCase()),
		)
	const { data, isLoading } = useQuery(
		getListRoomOfGameQuery(roomId, 0, 10, roomSearch, level),
	)
	const [, setRoomListSearch] = useAtom(roomListFilteredAtom)
	useEffect(() => {
		if (data) {
			setRoomListSearch(data.rooms)
		}
	}, [roomSearch, data, level])
	const roomListFiltered = roomListFilteredID?.map(item =>
		dataList?.find(result => result.id === item),
	)

	function handleRoomSearch(e) {
		if (roomSearch == null || roomSearch === '') {
			setRoomListSearch([])
		}
		// setRoomListSearch(listRoomSearchApi)
		setRoomSearch(e.target.value)
	}

	// TODO: Implement copy paste on searching ID, currently not update setRoomListSearch immediately
	// function handleRoomSearchPaste(e) {
	// 	setRoomListSearch(e.clipboardData.getData('Text'))
	// }
	return (
		<div
			className={`search-bar search-bar-roompage 
			${isMobileMD ? 'search-bar-roompage__mobile' : ''} mt-3 mt-md-auto`}
		>
			<SearchBar
				type="number"
				value={roomSearch}
				onChange={handleRoomSearch}
				onPaste={e => e.preventDefault()}
				onDrop={e => e.preventDefault()}
				placeholder={t('room.search_id')}
			/>
			<div className="d-flex">
				{getUserinfo() ? (
					<Button
						className={`createroom-btn ${isMobileMD ? 'createroom-btn-mobile' : ''
							}`}
						variant="primary"
						onClick={openCreateRoom}
					>
						<img src={addRoomIcon} width={16} height={18} alt="" />
						<p>{t('room.create_room')}</p>
					</Button>
				) : (
					<Button
						className={`createroom-btn ${isMobileMD ? 'createroom-btn-mobile' : ''
							}`}
						variant="primary"
					// onClick={openCreateRoom}
					>
						<Link
							style={{
								color: 'white',
								display: 'flex',
								gridGap: 5,
								gap: 5,
							}}
							to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
						>
							<img src={addRoomIcon} width={16} height={18} alt="" />
							<p>{t('room.create_room')}</p>
						</Link>
					</Button>
				)}

				{isMobileMD ? (
					getUserinfo() ? (
						<Button className="playnow-header mobile" onClick={handlePlayNow}>
							{t('game_card.play_btn')}
						</Button>
					) : (
						<Button className="playnow-header mobile" onClick={handlePlayNow}>
							<Link
								style={{
									color: 'white',
									display: 'flex',
									gridGap: 5,
									gap: 5,
								}}
								to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
							>
								{t('game_card.play_btn')}
							</Link>
						</Button>
					)
				) : null}
			</div>
			{user ? (
				modalCreateRoom ? (
					<CreateRoomModal
						show={modalCreateRoom}
						onHide={closeCreateRoom}
						title={t('room.create_room')}
					/>
				) : null
			) : // : modalShowLoginPass ? (
				// 	<LoginWebModal
				// 		modalShowLoginPass={modalShowLoginPass}
				// 		setModalShowLoginPass={setModalShowLoginPass}
				// 	/>
				// )
				null}
		</div>
	)
}

export default RoomSearchAndCreate
